import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const ScholarshipProcess = () => {
  const { t } = useTranslation();

  const steps = [
    { id: 1, title: "process.step1", description: "process.step1Desc" },
    { id: 2, title: "process.step2", description: "process.step2Desc" },
    { id: 3, title: "process.step3", description: "process.step3Desc" },
    { id: 4, title: "process.step4", description: "process.step4Desc" }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="mb-8"
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">
        {t('scholarships.processTitle')}
      </h2>
      
      <div className="space-y-8">
        {steps.map(step => (
          <motion.div
            key={step.id}
            whileHover={{ x: 5 }}
            className="flex"
          >
            <div className="flex-shrink-0 mr-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 text-primary-600 font-bold text-xl">
                {step.id}
              </div>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-800 mb-1">
                {t(step.title)}
              </h3>
              <p className="text-gray-600">
                {t(step.description)}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      
    </motion.div>
  );
};

export default ScholarshipProcess;
